import { MapCameraChangedEvent } from "@vis.gl/react-google-maps"
import { useState } from "react"

interface UseMapZoomOptions {
    initialZoom?: number
    minZoom?: number
    maxZoom?: number
    minZoomToShowLabel?: number
}

export const useMapZoom = ({
    initialZoom = 12,
    minZoom = 9,
    maxZoom = 16,
    minZoomToShowLabel = 13
}: UseMapZoomOptions = {}) => {
    const [zoom, setZoom] = useState(initialZoom)

    const handleZoomChange = (event: MapCameraChangedEvent) => {
        const newZoom = event.map.getZoom()!
        setZoom(newZoom)
    }

    const applyZoomConstraints = (map: google.maps.Map | null) => {
        if (!map) return

        const currentZoom = map.getZoom() || zoom
        if (currentZoom > maxZoom) {
            map.setZoom(maxZoom)
        } else if (currentZoom < minZoom) {
            map.setZoom(minZoom)
        }
    }

    const shouldShowLabel = zoom >= minZoomToShowLabel

    return {
        zoom,
        handleZoomChange,
        applyZoomConstraints,
        shouldShowLabel,
        minZoom,
        maxZoom,
        minZoomToShowLabel
    }
}
